import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { MenuComponent, MenuProps } from "../../../../../components/MenuComponent";
import { Toast } from "../../../../../hooks/toast";
import { confirmService } from "src/hooks/confirmHook";
import { TagsProduct } from "./TagsProduct";

const SET_SUPPLIER_PRODUCT_REQUEST = gql`
  mutation setStatusSupplierProductRequest($id: Int!, $status: SupplierStatusRequest) {
    setStatusSupplierProductRequest(id: $id, status: $status)
  }
`;

const SET_TYPE_SUPPLIER_APPROVED = gql`
  mutation setTypeSupplierProductApproved($id: Int!, $status: SupplierProductApproved, $data: OfferInput) {
    setTypeSupplierProductApproved(id: $id, status: $status, data: $data)
  }
`;

interface Props {
  item: any | {};
  index: number;
  status: "APPROVED" | "DRAFTING" | "REJECT" | "INCOMPLETE" | "DUPLICATED";
  type: "AVAILABLE" | "DISCONTINUE" | "OUT_OF_STOCK" | "DISCOUNT_OFFER" | string;
  onItem: (e: any) => any;
}

function isJsonString(data: string) {
  try {
    JSON.parse(data);
  } catch (e) {
    return false;
  }
  return true;
}

export function TableField(props: Props) {
  const { item, index, status, type, onItem } = props;
  const { push } = useHistory();
  const items: string[] = [];
  const [prview, setPreview] = useState(false);
  const [edit, setEdit] = useState(false);
  const [images, setImages] = useState<string[]>([]);
  const [tags] = useState(item.content.tags ? item.content.tags.split(",") : []);
  const title = isJsonString(item.content.title) ? JSON.parse(item.content.title) : item.content.title;
  const [setStatusSupplierProductRequest] = useMutation(SET_SUPPLIER_PRODUCT_REQUEST, {
    refetchQueries: ["supplierProductRequestList"],
    onCompleted: (data) => {
      Toast.onShow("Product was canceled", "success", "right");
    },
  });
  const [setTypeSupplierProductApproved] = useMutation(SET_TYPE_SUPPLIER_APPROVED, {
    refetchQueries: ["supplierProductRequestList"],
    onCompleted: (data) => {
      Toast.onShow("Product was change status", "success", "right");
    },
  });

  const menuItems: MenuProps[] = [
    {
      label: "Detail Product",
      // link: `/reports/performance/${item.id}?type=APPROVED`,
      onClick: () => {
        push(`/reports/performance/${item.id}?type=APPROVED`);
      },
      actived: status === "APPROVED",
      // isLink: true,
    },
    {
      label: "Edit Product",
      onClick: () => {
        push("/product/edit/" + item.id + "?type=" + status);
        // window.open(window.location.hostname + "/product/edit/" + item.id + "?type=" + status);
      },
      actived: true,
      // isLink: true,
      // link: "/product/edit/" + item.id + "?type=" + status,
    },
    {
      label: "Offer Edit",
      onClick: () => {
        if (item.lock_price === "LOCK") {
          return Toast.onShow(
            `Your product was Lock price. you can update other information but Price & Discount can't be change.`,
            "danger",
            "right",
          );
        }
        onItem(item);
      },
      actived: status === "APPROVED",
    },
    {
      label: "Available",
      onClick: () => {
        handleSetType("AVAILABLE");
      },
      actived: status === "APPROVED" && type !== "AVAILABLE",
    },
    {
      label: "Discontinue",
      onClick: () => {
        handleSetType("DISCONTINUE");
      },
      actived: status === "APPROVED" && type !== "DISCONTINUE",
    },
    {
      label: "Out of Stock",
      onClick: () => {
        handleSetType("OUT_OF_STOCK");
      },
      actived: status === "APPROVED" && type !== "OUT_OF_STOCK",
    },
    {
      label: "Order Item",
      onClick: () => {
        push("/product/order/" + item.id);
      },
      actived: status === "APPROVED",
    },
    {
      label: "Shipment History",
      onClick: () => {
        push("/product/shipment/" + item.id);
      },
      actived: status === "APPROVED",
    },
    {
      label: "Cancel Product",
      onClick: async () => {
        const result = await confirmService.show({
          message: "Are you sure want to cancel product?",
        });

        if (result) {
          setStatusSupplierProductRequest({
            variables: {
              id: Number(item.id),
              status: "CANCEL",
            },
          });
        }
      },
      actived: status === "DRAFTING",
    },
  ];

  const handleSetType = async (status: string) => {
    const result = await confirmService.show({
      message: `Are you sure want to change to ${status}?`,
    });
    if (result) {
      setTypeSupplierProductApproved({
        variables: {
          id: Number(item.id),
          status,
          discount: Number(item.content.discount),
        },
      });
    }
  };

  return (
    <tr key={index}>
      <td>{index + 1}</td>
      <td className="text-center" style={{ width: 100 }}>
        <div style={{ width: 100 }}>
          {prview && <RenderPreview items={images} onClose={() => setPreview(false)} />}
          <img
            src={"https:" + item.content.picture}
            alt=""
            style={{
              width: 75,
              height: 105,
              borderRadius: 4,
              objectFit: "cover",
            }}
            onClick={() => {
              setImages([item.content.picture]);
              setPreview(true);
            }}
          />
        </div>
      </td>
      <td className="text-center" style={{ width: 250 }}>
        <div className="cell-image-list">
          {item.content.images === null || item.content.images.length === 0 ? (
            <div>
              <sub>Empty Additional Image</sub>
            </div>
          ) : (
            item.content.images!.map((x: any, i: number) => {
              if (x === null) return <></>;
              items.push("https:" + x.src);
              if (i < 3) {
                return (
                  <img
                    src={"https:" + x.src}
                    alt=""
                    style={{ width: 40, height: (40 / 7.5) * 10.5 }}
                    className="cell-img"
                    onClick={() => {
                      setImages(item.content.images.map((img: any) => img.src));
                      setPreview(true);
                    }}
                    key={i}
                  />
                );
              }
              return <></>;
            })
          )}
          {item.content.images == null ? (
            <div></div>
          ) : (
            item.content.images.length > 3 && (
              <div className="cell-img-more">+ {item.content.images.length - 3} more</div>
            )
          )}
        </div>
      </td>
      <td style={{ textTransform: "capitalize" }}>
        {typeof title.en === "string" && (
          <span>
            <small>khmer: {title.km}</small>
            <br />
            <small>english: {title.en}</small>
            <br />
            <small>官话: {title.zh}</small>
          </span>
        )}
      </td>
      <td>
        <small>{item.content.supplier_code}</small> <br />
        <small>
          <a href={"https://www.l192.com/product/" + item.id} target="_blank" rel="noopener noreferrer">
            L192: {item.content.code}
          </a>
        </small>
        <br />
        {isNaN(item.content.rule) && status === "APPROVED" && (
          <small>
            Rule: <span className="badge badge-danger pt-1">{item.content.rule}</span>
          </small>
        )}
      </td>
      {status === "APPROVED" && (
        <td>
          <small>Sold Qty: {item.soldQty}</small>
          <br />
          <small>Renvenue: ${item.revenue}</small>
        </td>
      )}
      <td>
        <small>{item.content.stock}</small> <br />
        {item.content.remote_stock === "T" && <small className="text-danger">Remote Stock</small>}
      </td>
      <td style={{ textTransform: "capitalize" }} className="text-center">
        {!item.content.colours || item.content.colours === ""
          ? ""
          : item.content.colours.split(",").map((c: any) => {
              return (
                <>
                  <small>{c}</small>
                  <br />
                </>
              );
            })}
      </td>
      <td style={{ textTransform: "uppercase" }} className="text-center">
        {!item.content.size || item.content.size === ""
          ? ""
          : item.content.size.split(",").map((c: any) => {
              return (
                <>
                  <small>{c}</small>
                  <br />
                </>
              );
            })}
      </td>
      <td className="text-center bolder nowrap">
        <span className="text-success">
          {item.content.saleprice ? String(item.content.saleprice) : String(item.content.salesprice)} USD
        </span>
      </td>
      {status === "APPROVED" && (
        <td className="text-center bolder nowrap">
          <span className="text-success">{Number(item.content.discount).toFixed(2)} %</span>
        </td>
      )}
      {status === "APPROVED" && (
        <td className="text-center bolder nowrap">
          <span className="text-success">
            {Number(
              Number(item.content.saleprice) - (Number(item.content.saleprice) * Number(item.content.discount)) / 100,
            ).toFixed(2)}{" "}
            USD
          </span>
        </td>
      )}
      {status === "REJECT" && (
        <td>
          <small dangerouslySetInnerHTML={{ __html: item.rejectedReason }} />
        </td>
      )}
      {status === "APPROVED" && (
        <td onDoubleClick={async () => await setEdit(!edit)} style={{ width: 233, cursor: "pointer" }}>
          <small id={`tags${item.id}`} style={{ display: "none" }}>
            {JSON.stringify(tags)}
          </small>
          {edit ? (
            <TagsProduct item={item} setEdit={() => setEdit(false)} />
          ) : (
            <>
              {(item.content.tags ? item.content.tags.split(",") : []).map((tag: string) => {
                return <small className="badge rounded-pill badge-secondary mr-1">{tag}</small>;
              })}
            </>
          )}
        </td>
      )}
      <td className="text-center nowrap">
        <MenuComponent
          items={menuItems}
          menuButton={
            <div style={{ textDecoration: "none", cursor: "pointer" }}>
              <i className="os-icon os-icon-more-vertical" style={{ fontSize: "15pt" }}></i>
            </div>
          }
        />
      </td>
    </tr>
  );
}

export function RenderPreview({ items, onClose }: { items: string[]; onClose: () => void }) {
  const [index, setIndex] = useState<number>(items.length - 1);
  return (
    <div
      className="preview-cotainer"
      style={{
        justifyContent: items.length > 1 ? "space-between" : "center",
      }}
    >
      {items.length > 1 && (
        <i
          className="fas fa-chevron-left"
          onClick={() => {
            if (index <= 0) setIndex(items.length - 1);
            else {
              setIndex(index - 1);
            }
          }}
        />
      )}
      <img src={items[index]} alt="" />
      {items.length > 1 && (
        <i
          className="fas fa-chevron-right"
          onClick={() => {
            if (index === items.length - 1) setIndex(0);
            else setIndex(index + 1);
          }}
        />
      )}
      <i className="fas fa-times" style={{ position: "absolute", top: 15, right: 15 }} onClick={onClose} />
    </div>
  );
}
